import { SearchBox as HeadlessSearchBox } from '@coveo/headless';
import React from 'react';
import { useEffect, useState, FunctionComponent } from 'react';

interface SearchBoxProps {
	controller: HeadlessSearchBox;
	secondController?: HeadlessSearchBox;
}

export const SearchBox: FunctionComponent< SearchBoxProps > = ( props ) => {
	const { controller, secondController } = props;
	const [
		state,
		setState,
	] = useState( controller.state );
	const isEnterKey = ( e: React.KeyboardEvent< HTMLInputElement > ) => e.key === 'Enter';

	useEffect( () => controller.subscribe( () => setState( controller.state ) ), [] );

	return (
		<div className="coveo-advanced-query__searchbox alignwide">
			<label className="coveo-advanced-query__search">
				<button type="button" onClick={ () => controller.submit() }>
					<svg
						className="svg svg--svg-assets-svg-icon-search"
						role="img"
						focusable="false"
						height="24"
						width="24"
						aria-labelledby="svg-assets-svg-icon-search-title"
					>
						<title id="svg-assets-svg-icon-search-title">Search</title>
						<use xlinkHref="#svg-assets-svg-icon-search"></use>
					</svg>
				</button>
				<input
					className="coveo-advanced-query__input"
					type="text"
					placeholder="Search..."
					value={ state.value }
					onChange={ ( e ) => {
						controller.updateText( e.target.value );
						if ( secondController ) {
							secondController.updateText( e.target.value );
						}
					} }
					onKeyDown={ ( e ) => {
						if ( isEnterKey( e ) ) {
							controller.submit();
							if ( secondController ) {
								secondController.submit();
							}
						}
					} }
				/>
			</label>
			<ul>
				{ state.suggestions.map( ( suggestion ) => {
					const value = suggestion.rawValue;
					return (
						<li key={ value } onClick={ () => controller.selectSuggestion( value ) }>
							{ value }
						</li>
					);
				} ) }
			</ul>
		</div>
	);
};

// usage

/**
 * ```tsx
 * const options: SearchBoxOptions = {numberOfSuggestions: 8};
 * const controller = buildSearchBox(engine, {options});
 *
 * <SearchBox controller={controller} />;
 * ```
 */
